<mat-toolbar class="sub-toolbar">Dashboard</mat-toolbar>

<div class="dashboard-container">

	<div *ngIf="loading" class="loading-container">
		<mat-spinner></mat-spinner>
	</div>

	<!-- Regular User: Favorited Communities -->
	<ng-container *ngIf="!loading && user_role === 'user'">
		<h2 class="section-title">
			<mat-icon>favorite</mat-icon>
			Saved Communities
		</h2>
		<div *ngIf="favorite_communities.length === 0" class="empty-state">
			<mat-icon>favorite_border</mat-icon>
			<p>You haven't saved any communities yet.</p>
			<button mat-raised-button color="primary" routerLink="/search/">Browse Communities</button>
		</div>
		<div class="community-grid" *ngIf="favorite_communities.length > 0">
			<mat-card *ngFor="let community of favorite_communities" class="community-card" (click)="go_to_community(community.id)">
				<img mat-card-image *ngIf="community.banner" [src]="community.banner" [alt]="community.name">
				<mat-card-content>
					<mat-card-title>{{community.name}}</mat-card-title>
					<p *ngIf="community.address" class="community-address">
						<mat-icon>location_on</mat-icon>
						{{community.address.city}}, {{community.address.state}}
					</p>
				</mat-card-content>
				<mat-card-actions>
					<button mat-button color="primary">View Details</button>
				</mat-card-actions>
			</mat-card>
		</div>
	</ng-container>

	<!-- Community Owner: Managed Communities -->
	<ng-container *ngIf="!loading && user_role === 'owner'">
		<h2 class="section-title">
			<mat-icon>business</mat-icon>
			My Communities
		</h2>
		<div *ngIf="managed_communities.length === 0" class="empty-state">
			<mat-icon>business</mat-icon>
			<p>No communities are associated with your account.</p>
		</div>
		<mat-list *ngIf="managed_communities.length > 0" class="community-list">
			<mat-list-item *ngFor="let community of managed_communities" class="community-list-item">
				<img matListAvatar *ngIf="community.banner" [src]="community.banner" [alt]="community.name">
				<mat-icon matListAvatar *ngIf="!community.banner">business</mat-icon>
				<h3 matLine>{{community.name}}</h3>
				<p matLine *ngIf="community.address">{{community.address.city}}, {{community.address.state}}</p>
				<div class="list-actions">
					<button mat-icon-button color="primary" (click)="go_to_community(community.id)" matTooltip="View listing">
						<mat-icon>visibility</mat-icon>
					</button>
				</div>
			</mat-list-item>
		</mat-list>
	</ng-container>

</div>
